import { Box, Grid, Theme, Typography } from '@mui/material';
import React from 'react';
import { Bank } from '../../redux-store/types/api-types';
import { KeyValue } from './personalDetails';
import { Gridstyles } from './index';
import { SubHeading } from '../investors/components';
import { getBankAddress } from '../../utils/utilityFunctions';

export default function BankDetails({ banks = [] }: { banks: Partial<Bank>[] }): JSX.Element {
  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}>
        <Box>
          <Grid container >
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
              Investor&apos;s Bank Details
            </Typography>
            {banks.length === 0 ? (
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: 'text.primary',
                  textAlign: 'center',
                  my: 1.5,
                }}>
                No Bank Details
              </Grid>
            ) : (
              banks.map((bank, index: number) => {
                const title = ['Bank 1 Details', 'Bank 2 Details', 'Bank 3 Details', 'Bank 4 Details', 'Bank 5 Details'][index];
                const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);
                return (
                  <React.Fragment key={bank.id}>
                    <SubHeading sx={{ letterSpacing: "0.02px" }}>{title}</SubHeading>

                    <Grid
                      item
                      container
                      // pt={2}
                      // pb={5}
                      rowSpacing={3}
                      columnSpacing={5.5}
                      direction="row"
                    // justifyContent="space-between"
                    // alignItems="flex-start"
                    >
                      <KeyValue title={'IFSC Code*'} description={bank.ifscCode} />
                      <KeyValue
                        title={'Bank Account Number*'}
                        description={bank.bankAccountNumber}
                      />
                      <KeyValue title={'MICR Code'} description={bank.micrCode} />
                      <KeyValue title={'Bank Type'} description={bank.bankAccountType} />
                      {/* <KeyValue title={'Bank Currency*'} description={bank.currency} /> */}
                      <KeyValue title={'Bank Name'} description={bank.bankName} />
                      <KeyValue title={'Branch Name'} description={bank.bankBranch} />
                      {/* <KeyValue
                        title={`Bank Address`}
                        description={`${bankAddress}`}
                        sx={{
                          textTransform: 'capitalize',
                        }}
                      /> */}
                      <KeyValue
                        title={`Default Bank Account*`}
                        description={bank.defaultBankAccount ? 'Yes' : '-'}
                      />
                    </Grid>
                    {/* </Gridstyles> */}
                  </React.Fragment>
                );
              })
            )}
          </Grid>
        </Box>
      </Box >
    </>
  );
}
